
define('ldsh!modules/form_editor/templates/preview_check_group_amp', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<label\n  class="control-label col-sm-3"\n  for="" style="display: block;">' +
((__t = ( labelVisible ? labelText : "" )) == null ? '' : __t) +
'</label>\n\n<div class="col-sm-9 js-control js-items ' +
((__t = ( alignLeft ? 'predef-item' : '' )) == null ? '' : __t) +
'"></div>\n\n<span class="hidden-no-amp"\n       validation-for="' +
((__t = ( ampStateId )) == null ? '' : __t) +
'-anythingChecked"\n       visible-when-invalid="valueMissing">' +
((__t = (errorMessage)) == null ? '' : __t) +
'</span>\n\n<input id="' +
((__t = ( ampStateId )) == null ? '' : __t) +
'-anythingChecked"\n       value="' +
((__t = ( ampStateId )) == null ? '' : __t) +
'"\n       type="checkbox"\n       data-amp-state-id="' +
((__t = ( ampStateId )) == null ? '' : __t) +
'"\n       data-amp-state-content=\'{"choiceChecked": 0}\'\n       [checked]="' +
((__t = ( ampStateId )) == null ? '' : __t) +
'.choiceChecked > 0 ? \'checked\' : \'\'"\n       style="display:none"\n       ' +
((__t = ( isRequired ? 'required' : '' )) == null ? '' : __t) +
'\n/>\n\n\n\n';

}
return __p
};});

